import { NavLink } from "react-router-dom";

const tabs = [
  { to: "/AlternativeTherapies", label: "Therapy Requests" },
  { to: "/Bids", label: "Bids" },
];

const TherapyModuleTabs = () => (
  <div className="mb-5">
    <h1 className="text-xl font-semibold tracking-tight text-slate-900">Alternative Therapies</h1>
    <div className="mt-3 flex gap-6 border-b border-slate-200">
      {tabs.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          end
          className={({ isActive }) =>
            `-mb-px border-b-2 pb-2.5 text-sm font-medium transition ${
              isActive
                ? "border-sky-600 text-sky-700"
                : "border-transparent text-slate-500 hover:border-slate-300 hover:text-slate-800"
            }`
          }
        >
          {t.label}
        </NavLink>
      ))}
    </div>
  </div>
);

export default TherapyModuleTabs;
